import { Outlet } from "react-router-dom";

export default function EventsLayout() {
  return <Outlet />;
}
